<template>
    <div class="icon-picker">
        <div class="d-flex align-items-center mb-2">
            <i class="mdi icon-picker-current mr-2"
                v-bind:class="value ? `mdi-${value}` : 'mdi-help-circle-outline text-muted'"></i>
            <b-form-input
                v-model="search"
                v-bind:placeholder="$t('MDIICON_SEARCH')"
                v-on:input="load"/>
            <b-button
                v-if="value"
                class="ml-2"
                variant="outline-secondary"
                v-on:click.prevent="pick(null)">{{ $t('MDIICON_NONE') }}</b-button>
        </div>

        <div class="icon-picker-grid">
            <button
                type="button"
                v-for="name in names"
                :key="name"
                :title="name"
                class="icon-picker-item"
                v-bind:class="{ active: (name === value) }"
                v-on:click.prevent="pick(name)">
                <i class="mdi" v-bind:class="`mdi-${name}`"></i>
            </button>

            <div v-if="names.length === 0" class="text-muted small p-2">{{ $t('MDIICON_EMPTY') }}</div>
        </div>
    </div>
</template>

<script>
import Api from '@/api/Modules';

export default
{
    name: 'IconPicker',
    props:
    {
        value:
        {
            type: String,
            default: null,
        },
    },
    data()
    {
        return {
            search: '',
            names: [],
            timeout: null,
        };
    },
    created()
    {
        this.load();
    },
    beforeDestroy()
    {
        if (this.timeout != null)
        {
            clearTimeout(this.timeout);
        }
    },
    methods:
    {
        // there are close to seven thousand names, so the search runs on the
        // server and only the first screenful comes back
        load()
        {
            const me = this;

            if (me.timeout != null)
            {
                clearTimeout(me.timeout);
            }

            me.timeout = setTimeout(() =>
            {
                me.timeout = null;

                Api.getMdiIcons({ search: me.search }, (data) =>
                {
                    if (data && !data.error)
                    {
                        me.names = data.data;
                    }
                });
            }, 250);
        },
        pick(name)
        {
            this.$emit('input', name);
        },
    },
};
</script>
